// platform/* page translations
const platform = {
  layout: {
    menu: {
      companies: 'Companies',
      users: 'All Users',
      status: 'System Status',
      licenses: 'Licenses',
    },
  },
  companies: {
    stats: {
      total: 'Total Companies',
      active: 'Active Companies',
      users: 'Total Users',
      equipments: 'Total Equipment',
    },
    listTitle: 'Company List',
    addBtn: 'Register Company',
    loading: 'Loading...',
    empty: 'No companies registered.',
    col: {
      code: 'Code',
      name: 'Name',
      schema: 'Schema',
      ceo: 'CEO',
      users: 'Users',
      plan: 'Plan',
      status: 'Status',
      createdAt: 'Registered',
      actions: 'Actions',
    },
    usersSuffix: '{n}',
    actions: {
      delete: 'Delete',
    },
    confirmDelete: 'Are you sure you want to delete "{name}"?\n\nDeleting will remove all the following data:\n- Company information\n- All user accounts\n- Tenant schema and data\n\nThis action cannot be undone.',
    alertDeleted: '"{name}" company has been deleted.',
    alertDeleteFail: 'Delete failed: {error}',
    alertDeleteError: 'An error occurred while deleting the company.',
    alertUnknownError: 'Unknown error',
  },
  companyRegister: {
    title: 'Register Company',
    sectionBasic: 'Basic Information',
    sectionContact: 'Contact Information',
    sectionSubscription: 'Subscription',
    sectionAdmin: 'Administrator Account',
    adminDescription: 'Administrator account information that will be created with the company.',
    fields: {
      name: 'Company Name',
      code: 'Company Code',
      schema: 'Schema Name',
      ceo: 'CEO Name',
      businessNumber: 'Business Registration Number',
      contactEmail: 'Contact Email',
      contactPhone: 'Contact Phone',
      address: 'Address',
      plan: 'Subscription Plan',
      status: 'Subscription Status',
      maxUsers: 'Max Users',
      maxEquipments: 'Max Equipment',
      adminUsername: 'Admin Username (Email)',
      adminEmail: 'Admin Email',
      adminPassword: 'Password',
      adminPasswordConfirm: 'Confirm Password',
    },
    placeholder: {
      name: 'Enter company name',
      code: 'Lowercase letters and numbers only (e.g., company1)',
      schema: 'Auto-generated when company code is entered',
      ceo: 'Enter CEO name',
      businessNumber: 'Numbers only',
      contactEmail: 'company@example.com',
      contactPhone: '02-1234-5678',
      address: 'Enter company address',
      adminUsername: 'admin@example.com',
      adminEmail: 'admin@example.com',
      adminPassword: 'At least 8 characters',
      adminPasswordConfirm: 'Re-enter password',
    },
    schemaHint: 'Auto-generated based on company code',
    plan: {
      basic: 'Basic',
      standard: 'Standard',
      premium: 'Premium',
      enterprise: 'Enterprise',
    },
    status: {
      trial: 'Trial',
      active: 'Active',
      suspended: 'Suspended',
    },
    cancel: 'Cancel',
    submit: 'Register Company',
    submitting: 'Registering...',
    success: 'Company registered successfully.',
    fail: 'Failed to register company.',
    error: 'An error occurred while registering the company.',
    validation: {
      nameRequired: 'Please enter company name',
      codeRequired: 'Please enter company code',
      codeLength: 'Company code must be 2-20 characters',
      ceoRequired: 'Please enter CEO name',
      businessNumberInvalid: 'Invalid business number format (e.g., 123-45-67890)',
      contactEmailInvalid: 'Invalid email format',
      contactPhoneInvalid: 'Invalid phone format (e.g., 02-1234-5678)',
      maxUsersMin: 'Must be at least 1',
      maxEquipmentsMin: 'Must be at least 1',
      adminUsernameRequired: 'Please enter admin username (email)',
      adminEmailInvalid: 'Invalid email format',
      adminEmailRequired: 'Please enter admin email',
      adminPasswordRequired: 'Please enter password',
      adminPasswordLength: 'Password must be at least 8 characters',
      adminPasswordMismatch: 'Passwords do not match',
    },
  },
  globalUsers: {
    stats: {
      total: 'Total Users',
      admin: 'Administrators',
      active: 'Active Users',
    },
    listTitle: 'User List',
    filterAllCompanies: 'All Companies',
    loading: 'Loading...',
    empty: 'No users.',
    col: {
      name: 'Username',
      email: 'Email',
      company: 'Company',
      role: 'Role',
      status: 'Status',
      lastLogin: 'Last Login',
    },
    role: {
      superAdmin: 'Super Admin',
      admin: 'Admin',
      user: 'User',
    },
    statusActive: 'Active',
    statusInactive: 'Inactive',
  },
  systemStatus: {
    stats: {
      totalCompanies: 'Total Companies',
      activeCompanies: 'Active Companies',
      totalUsers: 'Total Users',
      activeUsers: 'Active Users',
    },
    serviceStatus: 'Service Status',
    refresh: 'Refresh',
    col: {
      service: 'Service',
      status: 'Status',
      url: 'URL',
    },
    statusRunning: 'Running',
    statusError: 'Error',
    noStatus: 'No status received from the server',
    etlTitle: 'ETL Status',
    etl: {
      lastRun: 'Last Run',
      status: 'Status',
      records: 'Records Processed',
      sync: 'Sync Interval',
      success: 'Success',
      noData: 'No Data',
      error: 'Error',
      recordsSuffix: '{n}',
    },
    dbTitle: 'Database Status',
    db: {
      tables: 'Total Tables',
      records: 'Total Records',
      size: 'DB Size',
      tablesSuffix: '{n}',
    },
  },
  licenseManagement: {
    stats: {
      total: 'Total Licenses',
      active: 'Active Licenses',
      expiring: 'Expiring Soon (within 30 days)',
    },
    listTitle: 'License List',
    loading: 'Loading...',
    empty: 'No licenses.',
    col: {
      company: 'Company',
      type: 'License Type',
      users: 'Users',
      equipments: 'Equipment',
      startDate: 'Start Date',
      endDate: 'Expiration',
      status: 'Status',
    },
    type: {
      enterprise: 'Enterprise',
      standard: 'Standard',
      basic: 'Basic',
      trial: 'Trial',
    },
    daysRemaining: '{n} days left',
    statusActive: 'Active',
    statusExpired: 'Expired',
  },
};

export default platform;
